module.exports = __webpack_public_path__ + "static/media/SDO.6e307a34.jpg";